import { createReducer } from "typesafe-actions";
import { loadTaxonomyAsync, searchTaxonomyAsync, applyFilter, removeFilter, resetAndReplaceFilter, setProductProperty } from "../actions/ProductsSearchActions";
import { Throwing } from "../../models/common";
import { SearchFilter, CategoryFilter, PropertyFilter, ANY_PROP_OPTION, UNSET_PROP_OPTION } from "../../models/SearchFilter";
import { TaxonomyElement } from "../../api/models/TaxonomyElement";
import { ProductProperty, ProductPropertyOption } from "../../api/models/ProductProperty";
import { itemsSelector } from "../selectors";
import { ProductProp } from "../../models/ProductProp";


interface ProductsSearchState extends Throwing {
    searchBusy: boolean,
    taxonomyBusy: boolean,
    taxonomy: TaxonomyElement | null,
    taxonomyLeafs: TaxonomyElement[],
    searchResults: TaxonomyElement[],
    categoriesFacetResult: { [id: string]: number },
    appliedCategoryFilters: CategoryFilter[],
    currentCategoryFilters: CategoryFilter[],
    topCategoryFilters: CategoryFilter[],
    appliedPropertyFilters: PropertyFilter[],
    currentProductProperties: ProductProp[],
    totalResults: number,
    highlights: { [id: string]: string[] },
    propertyOptionsFacets: { [id: string]: number },
    
    availablePropertiesConfigurations: {[catId:string]:[{[propId:string]: string}]}
}

const initialState: ProductsSearchState = {
    searchBusy: false,
    taxonomyBusy: false,
    taxonomy: null,
    taxonomyLeafs: [],
    searchResults: [],
    categoriesFacetResult: {},
    appliedCategoryFilters: [],
    currentCategoryFilters: [],
    topCategoryFilters: [],
    appliedPropertyFilters: [],
    currentProductProperties: [],
    totalResults: 0,
    highlights: {},
    propertyOptionsFacets: {},
    availablePropertiesConfigurations: {}
}



export const loadTaxonomyReducer = createReducer(initialState)
    .handleAction(loadTaxonomyAsync.request, (state) => { return { ...state, taxonomyBusy: true } })
    .handleAction(loadTaxonomyAsync.success, (state, action) => {
        console.time('leafs')
        var leafs = itemsSelector(action.payload)
        console.timeEnd('leafs')

        state.currentCategoryFilters = getCurrentCategoryFilters(state.appliedCategoryFilters.slice(-1)[0], state.categoriesFacetResult, leafs, action.payload).slice()
        if (state.topCategoryFilters.length === 0)
            state.topCategoryFilters = getCurrentCategoryFilters(state.appliedCategoryFilters.slice(-1)[0], state.categoriesFacetResult, leafs, action.payload).slice()

        return { ...state, taxonomyBusy: false, taxonomy: action.payload, taxonomyLeafs: leafs }
    })
    .handleAction(loadTaxonomyAsync.failure, (state, action) => { return { ...state, taxonomyBusy: false, error: action.payload } })

    .handleAction(searchTaxonomyAsync.request, (state) => { return { ...state, searchBusy: true } }) //, searchResults: []
    .handleAction(searchTaxonomyAsync.success, (state, action) => {
        let resultsMerged = action.payload.products
        //Set the available properties
        if(action.payload.availableProductProperties)
            for (let i = 0; i < resultsMerged.length; i++) {
                let avProps: [{ [propId: string]: string }] = action.payload.availableProductProperties[resultsMerged[i].id]
                if (avProps.length > 0) {
                    resultsMerged[i]._availableProperties = resultsMerged[i].properties.filter( p => avProps.find(a => a[p.id] !== undefined ) !== undefined)
                    for(let j =0; j < resultsMerged[i]._availableProperties.length; j++){
                        let propId = resultsMerged[i]._availableProperties[j].id
                        let availableOptions: string[] = removeDuplicates(avProps.filter(a => a[propId] !== undefined ).map(b => b[propId]))
                        resultsMerged[i]._availableProperties[j].options = resultsMerged[i]._availableProperties[j].options.filter( o => availableOptions.find(ao => ao === o.id) !== undefined)
                    }
                }
            }

        

        if (action.payload.nextPage) {
            let newUnique = action.payload.products.filter((p) => state.searchResults.find((p2) => p2.id === p.id) === undefined)
            resultsMerged = state.searchResults.concat(newUnique)
        }

        let hlFormatted: any = {}
        for (let i = 0; i < Object.keys(action.payload.highlights).length; i++) {
            let id = Object.keys(action.payload.highlights)[i]
            if (action.payload.highlights[id]['name'] !== undefined)
                hlFormatted[id] = action.payload.highlights[id]['name']
        }




        //update quantities of applied filters:
        for (let i = 0; i < state.appliedCategoryFilters.length; i++)
            state.appliedCategoryFilters[i].count = action.payload.facetsByField['category'][state.appliedCategoryFilters[i].taxonomyReference!.id]

        //update quantities of current filters:
        for (let i = 0; i < state.currentCategoryFilters.length; i++)
            state.currentCategoryFilters[i].count = action.payload.facetsByField['category'][state.currentCategoryFilters[i].taxonomyReference!.id]

        //Setup the product properties filters based on current category
        //For the restaurant search, there always must be a single category applied, based on order sheet type
        if (state.appliedCategoryFilters.length > 0 && action.payload.products.length > 0)
            //state.currentProductProperties = getSubProperties2(action.payload.productProperties, action.payload.facetsByField['property'], action.payload.facetsByField['property_option'])    
            state.currentProductProperties = getSubProperties(state.appliedCategoryFilters[state.appliedCategoryFilters.length - 1].taxonomyReference!, action.payload.facetsByField['property'], action.payload.facetsByField['property_option'])

        return { ...state, searchBusy: false, searchResults: resultsMerged, categoriesFacetResult: action.payload.facetsByField['category'], totalResults: action.payload.foundProducts, highlights: hlFormatted, propertyOptionsFacets: action.payload.facetsByField['property_option'], availablePropertiesConfigurations: Object.assign(state.availablePropertiesConfigurations, action.payload.availableProductProperties) }
    })
    .handleAction(searchTaxonomyAsync.failure, (state, action) => { return { ...state, searchBusy: false, error: action.payload } })

    .handleAction(applyFilter, (state, action) => {
        function addFilter(filters: SearchFilter[], toAdd: SearchFilter) {
            if (filters.find((f: SearchFilter) => f.id === toAdd.id) === undefined)
                filters.push(toAdd)

            return filters
        }

        if (action.payload instanceof PropertyFilter) {
            let newArray = state.appliedPropertyFilters.slice()
            state.appliedPropertyFilters = addFilter(newArray, action.payload) as PropertyFilter[]
        }
        else if (action.payload instanceof CategoryFilter) {

            let newArray = state.appliedCategoryFilters.slice()
            state.appliedCategoryFilters = addFilter(newArray, action.payload) as CategoryFilter[]
            //state.currentProductProperties = getSubProperties(, state.categoriesFacetResult, state.propertyOptionsFacets)
            state.currentProductProperties = getSubProperties(state.appliedCategoryFilters[state.appliedCategoryFilters.length - 1].taxonomyReference!, state.categoriesFacetResult, state.propertyOptionsFacets)

            state.currentCategoryFilters = getCurrentCategoryFilters(state.appliedCategoryFilters.slice(-1)[0], state.categoriesFacetResult, state.taxonomyLeafs, state.taxonomy)
        }
        else
            console.log("Unknown filter type.")

        return { ...state }
    })

    .handleAction(removeFilter, (state, action) => {
        function removeFilter(filters: SearchFilter[], toRemove: SearchFilter) {
            return filters.filter((f: SearchFilter) => f.id !== toRemove.id)
        }

        if (action.payload instanceof PropertyFilter) {
            let newArray = state.appliedPropertyFilters.slice()
            state.appliedPropertyFilters = removeFilter(newArray, action.payload) as PropertyFilter[]
        }
        else if (action.payload instanceof CategoryFilter) {
            //Case when we are applying a orderSheet category filter
            let newArray = state.appliedCategoryFilters.slice()
            state.appliedCategoryFilters = removeFilter(newArray, action.payload) as CategoryFilter[]
            state.currentCategoryFilters = getCurrentCategoryFilters(state.appliedCategoryFilters.slice(-1)[0], state.categoriesFacetResult, state.taxonomyLeafs, state.taxonomy)
            //state.currentProductProperties = getSubProperties(state.appliedCategoryFilters[state.appliedCategoryFilters.length - 1].taxonomyReference!, state.categoriesFacetResult, state.propertyOptionsFacets)
        }
        else
            console.log("Unknown filter type.")

        return { ...state }
    })

    //This function resets all filters and sets the provided filters, if any.
    .handleAction(resetAndReplaceFilter, (state, action) => {
        let appliedPropertyFilters: PropertyFilter[] = action.payload.propertyFilter === null ? [] : state.appliedPropertyFilters.slice()
        let appliedCategoryFilters: CategoryFilter[] = action.payload.categoryFilter === null ? [] : state.appliedCategoryFilters.slice()

        if (action.payload.propertyFilter) {
            appliedPropertyFilters = state.appliedPropertyFilters.slice()

            appliedPropertyFilters = appliedPropertyFilters.filter((f: PropertyFilter) => f.propId !== action.payload.propertyFilter!.propId)
            if (action.payload.propertyFilter.id !== ANY_PROP_OPTION && action.payload.propertyFilter.id !== UNSET_PROP_OPTION)
                appliedPropertyFilters.push(action.payload.propertyFilter)
        }

        if (action.payload.categoryFilter) {
            appliedCategoryFilters = [action.payload.categoryFilter]
            state.currentProductProperties = appliedCategoryFilters.map((acf) => acf.taxonomyReference!.properties).reduce((p1, p2) => { return p1.concat(p2) }).map((p) => ProductProperty2ProductProp(p, state.propertyOptionsFacets))
            state.currentCategoryFilters = getCurrentCategoryFilters(appliedCategoryFilters.slice(-1)[0], state.categoriesFacetResult, state.taxonomyLeafs, state.taxonomy)
        }

        return { ...state, appliedCategoryFilters: appliedCategoryFilters, appliedPropertyFilters: appliedPropertyFilters }
    })
    .handleAction(setProductProperty, (state, action) => {
        var searchResults: TaxonomyElement[] = JSON.parse(JSON.stringify(state.searchResults))
        var prod = searchResults.find(sr => sr.id === action.payload.catalogueProductId)
        let availableProperties: ProductProperty[] = []
        
        if(prod !== undefined){
            let prodProperties: ProductProperty[] = JSON.parse(JSON.stringify(prod.properties))

            let availableOptions : string[] = []
            let currentOptions : string[] = action.payload.selectedProperties.flatMap( p => p.options).map(o => o.id)
            let productConfigurations = state.availablePropertiesConfigurations[prod.id]
          
            for(let i = 0; i < productConfigurations.length; i++ ){
                let confOptions: string[] = Object.values(productConfigurations[i])
                let isValid = currentOptions.every(co =>  confOptions.find(c => co === c) !== undefined)
                if(isValid)
                    availableOptions = availableOptions.concat(confOptions)
            }

            if(action.payload.selectedProperties.length > 0)
                availableOptions = availableOptions.concat(productConfigurations.flatMap(pc => pc[action.payload.selectedProperties[action.payload.selectedProperties.length -1].id]).filter(pc => pc !== undefined) )
            availableOptions = removeDuplicates(availableOptions)


            for(let i = 0; i< availableOptions.length; i++){
                if(availableProperties.find(p => containsOption(p, availableOptions[i])) === undefined ){
                    let prop = prodProperties.find(p => containsOption(p,availableOptions[i]))!
                    prop.options = prop.options.filter(o => availableOptions.find(ao => ao === o.id) !== undefined )
                    availableProperties.push(prop)
                }
            }

            //Handle situation when newly selected property, excludes the other property selected before
            let currOptionsToReset = currentOptions.filter(co => availableOptions.find(ao => ao == co) === undefined)
            if(currOptionsToReset.length > 0){
                let updatedSelectedProperties = action.payload.selectedProperties
                for(let i = 0; i < currOptionsToReset.length; i++)
                    updatedSelectedProperties = updatedSelectedProperties.filter(sp => sp.options.find(op => op.id === currOptionsToReset[i]) === undefined)
                
                prod!._selectedProperties = updatedSelectedProperties
            }
            else
                prod!._selectedProperties = action.payload.selectedProperties

            prod!._availableProperties = availableProperties
        }



        return {...state, searchResults }
    })

const containsOption = (prop: ProductProperty, optionId: string) =>{
    return prop.options.find(o => o.id === optionId) !== undefined
}



const getCurrentCategoryFilters = (lastFilter: CategoryFilter, facetResults: { [id: string]: number }, taxonomyLeafs: TaxonomyElement[], taxonomy: TaxonomyElement | null) => {
    const matchFacet = (name: string) => {
        return facetResults[name] | 0
    }

    if (lastFilter) {
        let items = lastFilter.taxonomyReference!.subcategories.filter((f) => taxonomyLeafs.find((tf) => tf.id === f.id) === undefined).map((te) => {
            return new CategoryFilter(te.id, te.name, matchFacet(te.id), te)
        })
        return items
    }
    else
        if (taxonomy !== null) {
            return taxonomy.subcategories.map((te) => {
                return new CategoryFilter(te.id, te.name, matchFacet(te.id), te)
            });
        }
        else
            return []
}

// const getSubProperties2 = (productProps: ProductProperty[], facetResults: { [id: string]: number }, facetOptionsResults: { [id: string]: number }): ProductProp[] => {
//     let properts: ProductProp[] = []
//     for (let pp of productProps) {
//         properts.push(ProductProperty2ProductProp(pp, facetOptionsResults))
//     }
//     return properts
// }

const getSubProperties = (cat: TaxonomyElement, facetResults: { [id: string]: number }, facetOptionsResults: { [id: string]: number }): ProductProp[] => {
    let properts: ProductProp[] = []
    for (let subcat of cat.subcategories) {
        for (let prop of subcat.properties) {
            for (let opt of prop.options) {
                if (facetResults[prop.id] && properts.find((p) => p.id === prop.id) === undefined)
                    properts.push(ProductProperty2ProductProp(prop, facetOptionsResults))
            }
        }
        properts = properts.concat(getSubProperties(subcat, facetResults, facetOptionsResults).filter(p => properts.find(pp => p.id === pp.id) === undefined))
    }

    return properts
}

export const ProductProperty2ProductProp = (prop: ProductProperty, facetOptionsResults: { [id: string]: number } | null): ProductProp => {
    let orderedPropOptions: ProductPropertyOption[] = []
    orderedPropOptions = prop.options.sort((a, b) => (a.name > b.name) ? 1 : -1)
    return { id: prop.id, name: prop.name, type: prop.type, propertyOptions: orderedPropOptions.map((o: any) => new PropertyFilter(o.id, prop.id, o.name, prop.type, facetOptionsResults ? facetOptionsResults[o.name] : -1)) }
}

export function removeDuplicates<T>(array: T[]): T[] {
    return array.filter((a, b) => array.indexOf(a) === b)
  };

export default loadTaxonomyReducer;